import * as Blockly from 'blockly/core';

export function register(gen: any): void {
    gen.forBlock['setup'] = function (_block: Blockly.Block): string {
        return '';
    };
}
